<script setup>
import {computed, getCurrentInstance, onMounted, ref} from "vue";
import mypageUserService from "../../../../user/services/mypage/mypageUserService";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import { useAlertStore } from "../../../../../stores/alertStore";

const { $alert, $confirm } = useAlertStore();

const loadingStore = usePageLoadingStore()
const { $interests, $corpState, $ojfStateGb, $gbNameKR, $toast, $number, $pageListBoardNo, $yyyymmddHHmmss, $yyyymmdd, $yyyymm, $gb, $bizNum, $userGbKR } = getCurrentInstance().appContext.config.globalProperties;

const props = defineProps({
  user: {
    type: Object,
    default: () => ({}),
  },
});

const user = computed(() => props.user || {});

const userGbHistoryList = ref([]);

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);

// 검색조건 - 페이지 크기, 재직자 가입 현황 tab, 채용 진행 현황 tab
const pageSizeGroup = ref([
  { label:'10개씩 보기', value: '10' },
  { label:'30개씩 보기', value: '30' },
  { label:'50개씩 보기', value: '50' },
  { label:'100개씩 보기', value: '100' },
]);


// 1. 회원 유형 변경 내역 조회
const retrieveUserGbHistoryList = async () => {
  let paramObj = {
    userId: user.value.userId,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  loadingStore.loading = true;
  //loaded.value = false;
  mypageUserService.retrieveUserGbHistoryListByUserId(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        //loaded.value = true;
        //console.log(res);
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          userGbHistoryList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        } else {
        }
      }).catch( (res) =>  {
    console.log(res);
    loadingStore.loading = false;
    //loaded.value = true;
  });
}

// 2. 회원 유형 변경 상태 변경
const changeUserGbHistoryState = async (seq, stateGb) => {
  let confirmMsg;
  if ( stateGb === '02' ) {
    confirmMsg = ["신청건이 취소 처리됩니다.", "상태를 ‘취소’로 변경할까요?"];
  }
  const ok = await $confirm(confirmMsg, "변경");

  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      seq: seq,
      stateGb: stateGb
    }
    mypageUserService.changeUserGbHistoryState(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            $alert("변경하였습니다.");
            retrieveUserGbHistoryList();
          } else {
            console.log(res);
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      console.log(res);
    });
  }
}

// 페이지 선택
const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveUserGbHistoryList();
}

// 검색조건 - 페이지 크기 변경 이벤트
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;
  retrieveUserGbHistoryList();
}


onMounted(() => {
  retrieveUserGbHistoryList();
})

</script>
<template>
  <div class="list-top">
    <p>신청 <span>{{ $number(totalCount)}}</span>건</p>
    <div>
      <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
    </div>
  </div>

  <div class="table-form">
    <table class="horizontal" v-if="userGbHistoryList !== null">
      <tr>
        <th>NO</th>
        <th>신청일</th>
        <th>현재 회원 유형</th>
        <th>추가/변경 회원 유형</th>
        <th>상태</th>
        <th>상태 변경</th>
      </tr>
      <tr v-for="userGbHistory in userGbHistoryList">
        <td>{{ userGbHistory.boardNo }}</td>
        <td>{{ $yyyymmddHHmmss(userGbHistory.createDate) }}</td>
        <td>{{ $userGbKR(userGbHistory.beforeUserGb) }}</td>
        <td>{{ $userGbKR(userGbHistory.afterUserGb) }}</td>
        <td>{{ $gbNameKR('USER_GB_STATE_GB', userGbHistory.stateGb) }}</td><!-- 01 신청 02 취소 03 승인 04 거절 -->
        <td>
          <span v-if="userGbHistory.stateGb === '01'" data-title="신청 : ">
            <KSATextButton text="[신청 취소]" @click="changeUserGbHistoryState(userGbHistory.seq, '02')"/>
          </span>
          <span v-else>
            -
          </span>
        </td>
      </tr>
    </table>
  </div>
  <div class="result-none" v-if="userGbHistoryList.length === 0">
    신청건이 없습니다.
  </div>
  <Paginate
      v-if="userGbHistoryList.length > 0"
      v-model="currentPage"
      :page-count="totalPages"
      :click-handler="onSelectPage"
  />
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
</style>